import { render, staticRenderFns } from "./pemberitahuan-libur.vue?vue&type=template&id=74ce8848&"
import script from "./pemberitahuan-libur.vue?vue&type=script&lang=js&"
export * from "./pemberitahuan-libur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports